export enum GroupModalsName {
	Move = 'Move',
	Delete = 'Delete',
	ResetPassword = 'ResetPassword'
}

export interface GroupModalsProps {
	onSubmit: () => void;
}
